import React from "react";
import adBanner from "asset/images/ads/usdcAd.png";

export default function UsdcRightMock() {
    return (
        <img
            src={adBanner}
            alt="USDC promo"
            className="w-full object-cover h-36 rounded-md"
            loading="lazy"
            decoding="async"
        />
    );
}
